import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";

var ls = new SecureLS({encodingType: 'aes', isCompression: false, encryptionSecret: 'H4$1J3@*1qwe'});

export default createPersistedState({
    paths: ['auth'],
    key: 'data_info',
    storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
    },
});
